import { createSlice, current } from "@reduxjs/toolkit";

// create slice = combination of reducer and action

const name = "verfication";
const initialState = createInitialState();
const reducers = createReducers();
const slice = createSlice({ name, initialState, reducers });
//each slice have 3 elements first is name second is state, then reducer

// exports

export const verficationActions = { ...slice.actions };
export const verficationReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    // initialize state from local storage to enable user to stay logged in
    company: [],
    address: [],
    contact: [],
    payment: [],
    terms: [],
    document: [],
    newAddress: [],
    newContact:[]
  };
}

function createReducers() {
  return {
    addCompany,
    addAddress,
    addContact,
    addPayment,
    addTerms,
    addDocument,
    addNewAddress,
    addNewContact
  };

  function addCompany(state, action) {
    state.company = action.payload;
  }
  function addAddress(state, action) {
    state.address = action.payload;
  }
  function addContact(state, action) {
    state.contact = action.payload;
  }
  function addPayment(state, action) {
    state.payment = action.payload;
  }
  function addTerms(state, action) {
    state.terms = action.payload;
  }
  function addDocument(state, action) {
    state.document = action.payload;
  }
  function addNewAddress(state, action) {
    const existingAddress = current(state).newAddress;
    state.newAddress = [...existingAddress , action.payload];
  }
  function addNewContact(state, action){
    const existingContact = current(state).newContact;
    state.newContact = [...existingContact , action.payload];
  }
}
